
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

export default {
name: 'QueryCustomsStatus',
components: {
XInput,
XButton,
Group,
Cell,
Checker,
CheckerItem,
Divider,
Timeline,
TimelineItem
},
data () {
return {
ieFlag: 'E',
blno: '',
orderJGStatusList: [],
jgTips: ''
}
},
methods: {
submitQuery: function () {
let that = this
let url = '/wxapi/sw/getOrderSwStatusInfo?blno=' + that.blno + '&ieFlag=' + that.ieFlag
this.$axios.post(url, {}).then(function (res) {
if (res.meta.success) {
that.orderJGStatusList = res.data.list
if (that.orderJGStatusList.length < 1) {
that.jgTips = '暂无海关动态信息'
}
} else {
that.jgTips = '暂无海关动态信息'
console.error(res.meta.message)
if (res.redirect) {
window.location.href = res.data
} else {
that.$Msgbox.alert.show(res.meta.message, '异常提示')
}
}
}).catch(function (error) {
console.info(error)
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/tools/QueryCustomsStatus.vue